export const FLY_OUT_WIDTH = 278;
export const MENU_ITEM_SIZE = 50;
//# sourceMappingURL=constants.js.map